import {
	Autocomplete,
	Box,
	CircularProgress,
	FormControl,
	TextField,
	Typography
} from "@mui/material";
import {
	FreelancerOnboardingMySkillsStepViewModel,
	FreelancerOnboardingRegionViewModel
} from "../../../../../ViewModels/FreelancerOnboardingMySkillsStepViewModel";
import { useTranslation } from "react-i18next";
import { useRegions } from "../../../../../hooks/useReferential";
import { FormikProps } from "formik";

const FreelancerOnboardingMySkillsRegionsBloc = ({
	formik
}: {
	formik: FormikProps<FreelancerOnboardingMySkillsStepViewModel>;
}) => {
	const { data: regions, isLoading: isRegionsLoading } = useRegions();
	const { t } = useTranslation();

	return (
		<Box sx={{ mb: 4, width: "40%" }}>
			<Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
				{t("FreelancerOnboardingMySkills.regions.title")}
			</Typography>
			<Typography variant="body2" gutterBottom>
				{t("FreelancerOnboardingMySkills.regions.description")}
			</Typography>

			<FormControl fullWidth size="small" sx={{ width: "100%" }}>
				<Autocomplete
					multiple={true}
					disableCloseOnSelect={true}
					isOptionEqualToValue={(option, value) => option.id === value.id}
					getOptionLabel={e => t(`Regions.${e.label}`)}
					options={regions ?? []}
					value={formik.values.regionViewModels.map(x => x.region) ?? []}
					onChange={(_, newValue) => {
						formik.setFieldValue(
							"regionViewModels",
							newValue.map(
								region =>
									({
										id: formik.values.regionViewModels.filter(
											x => x.region.id === region.id
										)?.[0]?.id,
										region
									} as FreelancerOnboardingRegionViewModel)
							)
						);
					}}
					onBlur={() => {
						formik.setTouched({
							regionViewModels: formik.values.regionViewModels.map(() => ({
								id: true,
								region: {
									id: true,
									label: true
								}
							}))
						});
					}}
					renderInput={params => (
						<TextField
							{...params}
							placeholder={t("FreelancerOnboardingMySkills.regions.placeholder")}
							variant="outlined"
							error={
								formik.touched.regionViewModels &&
								(formik.touched.regionViewModels.length === 0 ||
									formik.touched.regionViewModels?.some(
										x => x.region?.id === true || x.region?.label === true
									) === true) &&
								Boolean(formik.errors.regionViewModels as string)
							}
							helperText={
								formik.touched.regionViewModels &&
								(formik.touched.regionViewModels.length === 0 ||
									formik.touched.regionViewModels?.some(
										x => x.region?.id === true || x.region?.label === true
									) === true) &&
								(formik.errors.regionViewModels as string)
							}
							sx={{
								width: "100%"
							}}
							slotProps={{
								input: {
									...params.InputProps,
									endAdornment: (
										<>
											{isRegionsLoading && <CircularProgress size={25} />}
											{params.InputProps?.endAdornment}
										</>
									)
								}
							}}
						/>
					)}
					sx={{ mb: 2 }}
				/>
			</FormControl>
		</Box>
	);
};

export default FreelancerOnboardingMySkillsRegionsBloc;
